module.exports = __webpack_public_path__ + "img/claus_neuhaus.9b051209.png";